import React from 'react'

import { PortalPage } from 'component-library-next'

import { LatestInteractionsTable } from '@app/modules/LatestInteractions/Components/LatestInteractionsTable'
import { NavBar } from '@app/NavBar'

export function LatestInteractionsPage() {
  return (
    <NavBar title='Letzte Beratungen'>
      <PortalPage hideFooter>
        <LatestInteractionsTable />
      </PortalPage>
    </NavBar>
  )
}
